import { z } from 'zod';
import { addressSchema } from './Address.js';

//--------------------------------
// Consent Data Schema
//--------------------------------
const consentDataSchema = z.object({
    ipAddress: z.string(),
    userAgent: z.string(),
    timestamp: z.string(),
});
//--------------------------------
// Banking Details Schema
//--------------------------------
const bankingDetailsSchema = z.object({
    accountNumber: z.string(),
    routingNumber: z.string(),
    accountType: z.enum(['CHECKING', 'SAVINGS']),
    accountClass: z.enum(['BUSINESS', 'PERSONAL']),
});
//--------------------------------
// Payment Details Schema
//--------------------------------
const paymentDetailsSchema = z.object({
    stripe: z
        .object({
        accountId: z.string(),
        accountLinkUrl: z.string(),
        detailsSubmitted: z.boolean(),
        chargesEnabled: z.boolean(),
        payoutsEnabled: z.boolean(),
    })
        .optional(),
    brex: z
        .object({
        vendorId: z.string(),
    })
        .optional(),
    plaid: z
        .object({
        stripeCustomerId: z.string().optional(),
        stripeSourceId: z.string().optional(),
        consentData: consentDataSchema.optional(),
    })
        .optional(),
});
//--------------------------------
// Payable Data Schema
//--------------------------------
const payableDataSchema = z.object({
    taxNumber: z.string(), // F-EIN or SSN (tax number) - should this perhaps be more general so individuals could also be sellers?
    payment: paymentDetailsSchema,
    legalName: z.string(),
    legalAddress: addressSchema,
});

export { bankingDetailsSchema, consentDataSchema, payableDataSchema, paymentDetailsSchema };
//# sourceMappingURL=Payable.js.map
